import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NavigationService } from './core/services/navigation.service';
import { TabService } from './core/services/tab.service';
import { UpdateService } from './core/services/update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'twc-admin-portal';

  currentLanguage = 'zh-hant-hk';
  faUserCircle = faUserCircle;

  constructor(
    private translate: TranslateService,
    private tabService: TabService,
    public navigation: NavigationService,
    private sw: UpdateService
  ) {
    this.translate.onLangChange.subscribe((res: LangChangeEvent) => {
      this.currentLanguage = res.lang;
    });
    this.navigation.startSaveHistory();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.tabService.isReadonly) {
      $event.returnValue = true;
    }
  }
}
